import React, { Component } from "react";
import { Button } from "react-bootstrap";
import {
  LuChevronDown, LuChevronLeft, LuChevronRight, LuChevronUp, LuMaximize, LuMinimize, LuRotateCcw, LuZoomIn, LuZoomOut,
} from "react-icons/lu";
import CopyButton from "./copyButton";

// A `title` rather than the app's Tooltip, which renders into <body> and so is not shown over a full-screen diagram.
const Control = ({ label, onClick, children }) => (
  <Button variant="light" size="sm" className="playground-icon-button" aria-label={label} title={label}
    onClick={onClick}>
    {children}
  </Button>
);

/**
 * The controls of a drawn mermaid diagram, three by three: full screen, up, zoom in; left, reset, right; copy source,
 * down, zoom out.
 *
 * Props:
 *   host   - the diagram's `.playground-mermaid`, the element full screen shows
 *   source - the mermaid definition, which Copy source copies
 *   viewer - () => the diagram's attachViewer controller, or null while it is not drawn
 */
export default class DiagramControls extends Component {
  constructor(props) {
    super(props);
    this.state = { fullScreen: false };
  }

  componentDidMount() {
    document.addEventListener("fullscreenchange", this.handleFullScreenChange);
  }

  componentWillUnmount() {
    document.removeEventListener("fullscreenchange", this.handleFullScreenChange);
  }

  handleFullScreenChange = () => {
    this.setState({ fullScreen: document.fullscreenElement === this.props.host });
  };

  toggleFullScreen = () => {
    const request = document.fullscreenElement === this.props.host
      ? document.exitFullscreen()
      : this.props.host.requestFullscreen();
    // A refusal leaves the page as it was, so there is nothing to undo.
    Promise.resolve(request).catch(() => {});
  };

  /** A handler that applies `move` to the viewer, when there is one. */
  act(move) {
    return () => {
      const viewer = this.props.viewer();
      if ( viewer ) {
        move(viewer);
      }
    };
  }

  render() {
    const { fullScreen } = this.state;
    return (
      <>
        {document.fullscreenEnabled
          ? <Control label={fullScreen ? "Exit full screen" : "Full screen"} onClick={this.toggleFullScreen}>
              {fullScreen ? <LuMinimize /> : <LuMaximize />}
            </Control>
          : <span aria-hidden="true" />}
        <Control label="Pan up" onClick={this.act(viewer => viewer.pan(0, -1))}><LuChevronUp /></Control>
        <Control label="Zoom in" onClick={this.act(viewer => viewer.zoomIn())}><LuZoomIn /></Control>
        <Control label="Pan left" onClick={this.act(viewer => viewer.pan(-1, 0))}><LuChevronLeft /></Control>
        <Control label="Reset view" onClick={this.act(viewer => viewer.reset())}><LuRotateCcw /></Control>
        <Control label="Pan right" onClick={this.act(viewer => viewer.pan(1, 0))}><LuChevronRight /></Control>
        <CopyButton text={this.props.source} label="Copy source" />
        <Control label="Pan down" onClick={this.act(viewer => viewer.pan(0, 1))}><LuChevronDown /></Control>
        <Control label="Zoom out" onClick={this.act(viewer => viewer.zoomOut())}><LuZoomOut /></Control>
      </>
    );
  }
}
